import axios from 'axios';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading/Loading';
import './Skills.css';

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();

class Skills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      line1: 'My Skills &',
      line2: 'Experience !!',
      SkillPageUrl: 'https://my-webpage-node.vercel.app/Skill/PercentData',
      SkillPageParaUrl: 'https://my-webpage-node.vercel.app/Skill/ParaData',
      skillPageExperienceUrl: 'https://my-webpage-node.vercel.app/Skill/Experience',
      SkillPageData: [],
      SkillPageParaData: [],
      skillPageExperienceData: [],
      textAnimationLine1: [],
      textAnimationLine2: [],
      loading: false
    }
  }
  async componentDidMount() {
    title.innerHTML = 'Skills'
    let tempArr1 = []
    let tempArr2 = []
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
        tempArr2[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
      textAnimationLine2: tempArr2
    })
    let SkillsPage = {
      SelectedPage: 2
    }
    this.props.SelectedPage('SelectedPage', SkillsPage)
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.loading && this.props.SkillPageProps.SkillPage.Loading) {
        let arr1 = this.state.textAnimationLine1;
        let arr2 = this.state.textAnimationLine2
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          arr2[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
            textAnimationLine2: arr2
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          arr2[countDownAni - 1] = { letterAni: 2 }
          arr2[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
            textAnimationLine2: arr2
          })
        }
      }
    }, 100);
    await axios.get(this.state.SkillPageParaUrl).then((res) => {
      this.setState({
        loading: true,
        SkillPageParaData: res.data
      })
    }).catch((err) => {
      console.log(err)
    })
    await axios.get(this.state.SkillPageUrl).then((res) => {
      this.setState({
        loading: true,
        SkillPageData: res.data
      })
    }).catch((err) => {
      console.log(err)
    })
    await axios.get(this.state.skillPageExperienceUrl).then((res) => {
      this.setState({
        loading: true,
        skillPageExperienceData: res.data
      })
    }).catch((err) => {
      console.log(err)
    })
  }

  render() {
    return (<>
      {this.state.loading && this.props.SkillPageProps.SkillPage.Loading ?
        <>
          <div className='mainDivSkillsPage'>
            <div className='TextDivisionSkills'>
              <div style={{ marginBottom: '0px' }} className='SkillHeadingDiv'>
                {this.state.line1.split('').map((ite, index) => {
                  return (<>{ite === ' ' ? <span className='SkillsAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 1 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }} onMouseLeave={() => {
                    setTimeout(() => {
                      let ani = this.state.textAnimationLine1
                      ani[index] = { letterAni: 2 }
                      this.setState({
                        textAnimationLine1: ani
                      })
                    }, 500)
                  }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'SkillsAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'SkillsAniLetterMouse SkillsAniLetter' : 'SkillsAniLetter'}>{ite}</span>}
                  </>)
                })}
              </div>
              <div className='SkillHeadingDiv'>
                {this.state.line2.split('').map((ite, index) => {
                  return (<>{ite === ' ' ? <span className='SkillsAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                    let ani = this.state.textAnimationLine2
                    ani[index] = { letterAni: 1 }
                    this.setState({
                      textAnimationLine2: ani
                    })
                  }} onMouseLeave={() => {
                    setTimeout(() => {
                      let ani = this.state.textAnimationLine2
                      ani[index] = { letterAni: 2 }
                      this.setState({
                        textAnimationLine2: ani
                      })
                    }, 500)
                  }} className={this.state.textAnimationLine2[index]?.letterAni === 0 || undefined || null ? 'SkillsAniLtr' : this.state.textAnimationLine2[index]?.letterAni === 1 ? 'SkillsAniLetterMouse SkillsAniLetter' : 'SkillsAniLetter'}>{ite}</span>}
                  </>)
                })}
              </div>
              <div className='detailedDescriptnSkill'>
                {this.state.SkillPageParaData ? this.state.SkillPageParaData.map((ite, index) => {
                  return (<>
                    <p className='DescpParaSkl'>{ite.skill}</p>
                  </>)
                }) : ''}
              </div>
            </div>
            <div className='secondDivSkill'>
              {this.state?.SkillPageData ? this.state.SkillPageData?.map((ite, index) => {
                return (<>
                  <div className='SkillLvlDiv'>
                    <h2 className='skillLvlDivHdn' style={{ color: `rgb${ite?.fontcolor}` }}>{ite?.skill}</h2>
                    <div className='skillLvlDivLvl'>
                      <div className='skillLvlDivBar' style={{ width: `${ite?.level}%`, backgroundColor: `rgb${ite?.color}` }} ></div>
                    </div>
                  </div>
                </>)
              }) : ''}
            </div>
          </div>
          <div className='experienceDivisionMain'>
            <div className='experienceDivSkill'>
              <div className='experienceDivSkillHeading'>
                <h1 className='headingExperience'>Experience</h1>
              </div>
            </div>
            <div className='experienceDesDiv'>
              {this.state?.skillPageExperienceData ? this.state.skillPageExperienceData.map((ite, index) => {
                return (<>
                  {ite?.experienceshow ? <div className='experienceOuterDiv'>
                    <div className='experienceOuterDivLeft'>
                      <div className='companyDetails1'>
                        <h2 className='marginZeroCls companyNameCls'>{ite?.companyName}</h2>
                        <a className='companyLink' target={'_blank'} href={ite?.companyWebsite} rel='noreferrer noopener'>{ite.companyWebsite}</a>
                        <h3 className='marginZeroCls companyPlaceCls'>{ite?.companyPlace}</h3>
                      </div>
                      <div className='companyDetails1'>
                        <h2 className='marginZeroCls companyPositionCls'>{ite?.position}</h2>
                        <h3 className='marginZeroCls companyYearCls'>{ite?.year}</h3>
                        <div className='knowledgeLearnt'>
                          {ite?.knowledge?.map((ite, index) => {
                            return (<>
                              <div className='KnowledgeLearntNames'>{ite}</div>
                            </>)
                          })}
                        </div>
                      </div>
                    </div>
                    <div className='experienceOuterDivRight'>
                      <h3 className='marginZeroCls companyDescriptionCls'>{ite?.companyDescription}</h3>
                      <h4 className='marginZeroCls workDescriptionCls'>{ite?.workDescription}</h4>
                    </div>
                  </div> : ''}
                </>)
              }) : ''}
            </div>
          </div>
        </>
        : <Loading />
      }
    </>);
  }
}

const mapStateToProps = (state) => ({
  SkillPageProps: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Skills));